import React from 'react'
import {
  Button,
  IconCaretLeft,
  IconCaretRight,
  ButtonProps,
  csx,
  dataAttr,
} from '@vtex/admin-ui'

export type ProductCarouselButtonProps = {
  direction: 'previous' | 'next'
} & ButtonProps

export const ProductCarouselButton = ({
  direction,
  ...props
}: ProductCarouselButtonProps) => {
  const isNextDirection = direction === 'next'

  return (
    <Button
      icon={direction === 'next' ? <IconCaretRight /> : <IconCaretLeft />}
      variant="primary"
      className={csx({
        display: 'none',
        zIndex: 1,
        left: isNextDirection ? 'unset' : '-20px',
        right: isNextDirection ? '-20px' : 'unset',
        boxShadow: '0px 0px 8px rgba(0, 0, 0, 0.1)',
        [dataAttr('variant', 'primary')]: {
          position: 'absolute',
          width: '2.5rem',
          height: '2.5rem !important',
          borderRadius: '100%',
          top: '35%',
        },
        '@desktop': {
          display: 'inline-block',
        },
      })}
      {...props}
    />
  )
}
